export var Paths;

(function (Paths) {
  Paths["ChatroomId"] = "/chatrooms/:chatroomId";
})(Paths || (Paths = {}));